<template>
  <div class="mobile_vote">
    <div class="mobile_vote_head">
      <div class="mobile_head_left">
        <a @click="goBack()">
          <i class="el-icon-arrow-left"></i>
        </a>
      </div>
      <span class="mobile_head_desc"> 请投票 </span>
      <div class="mobile_head_right">
        <a @click="refresh()">
          <i class="el-icon-refresh-right"></i>
        </a>
      </div>
    </div>
    <div class="mobile_vote_bar" ref="mobileVoteBar">
      <el-link
        type="primary"
        :underline="false"
        :disabled="pageIndex <= 1"
        @click="prevItem()"
      >
        <i class="el-icon-d-arrow-left"></i>上一项
      </el-link>
      <div class="mobile_bar_main">
        <div class="mobile_bar_title">
          {{ voteInfo.VoteName }}
        </div>
        <div class="mobile_bar_tips">
          <el-input-number
            size="mini"
            :controls="false"
            class="page_num"
            v-model="inputPageIndex"
            @blur="pageIndexBlur()"
          ></el-input-number>
          <span>
            /
            {{ voteInfo.ProjectTotalNum }}
          </span>
        </div>
      </div>
      <el-link
        type="primary"
        :underline="false"
        :disabled="pageIndex >= voteInfo.ProjectTotalNum"
        @click="nextItem()"
      >
        下一项<i class="el-icon-d-arrow-right"></i>
      </el-link>
    </div>
    <div class="mobile_vote_main" :style="voteMainStyle">
      <div
        class="mobile_project_box mobile_project_box_score"
        ref="mobileProjectBox"
        :style="voteProjectBoxStyle"
      >
        <div class="project_item">
          <div class="project_title">
            {{ pageIndex }}、
            {{ currentProject.VoteProjectName }}
          </div>
        </div>
        <div class="project_item">
          <i class="el-icon-s-opportunity icon_left icon_primary"></i>
          <div class="content">
            {{ currentProject.VoteProjectRemark }}
          </div>
          <a @click="changeShowAdditionalRemark()">
            <i
              class="el-icon-caret-bottom icon_right icon_primary"
              :style="
                currentProject.IsShowAdditionalRemark
                  ? 'transform: rotate(-180deg);transition: all .5s'
                  : 'transform: rotate(0deg);transition: all .5s'
              "
            ></i>
          </a>
        </div>
        <div
          class="project_item"
          v-show="currentProject.IsShowAdditionalRemark"
        >
          <i
            class="el-icon-s-opportunity icon_left icon_warning"
            v-show="currentProject.VoteProjectAdditionalRemark"
          ></i>
          <div
            class="content"
            v-html="currentProject.VoteProjectAdditionalRemark"
          ></div>
        </div>
        <div class="project_item">
          <div>
            <span class="total_score_lable"> 总分数： </span>
            <span class="total_score">
              {{ currentProject.AllScore ? currentProject.AllScore : 0 }}
            </span>
          </div>
        </div>
      </div>
      <div
        class="mobile_project_box"
        v-for="(item, index) in currentProject.ProjectRuleItemList"
        :key="index"
      >
        <div class="project_item">
          <div class="content">
            {{ index + 1 }}.{{ voteInfo.RuleItemList[index].Title }}
          </div>
          <a @click="item.IsShowContent = !item.IsShowContent">
            <i
              class="el-icon-caret-bottom icon_right icon_primary"
              :style="
                item.IsShowContent
                  ? 'transform: rotate(-180deg);transition: all .5s'
                  : 'transform: rotate(0deg);transition: all .5s'
              "
            ></i>
          </a>
          <div class="rule_detaile_score">
            <el-input-number
              size="mini"
              class="number"
              :controls="false"
              placeholder="打分"
              :precision="2"
              :min="item.ProjectRuleItemMinScore"
              :max="item.ProjectRuleItemMaxScore"
              v-model="item.ProjectRuleItemScore"
              @focus="projectRuleItemScore_focus(item)"
              @blur="projectRuleItemScore_blur(currentProject, item)"
            ></el-input-number>
          </div>
        </div>
        <div class="project_item" v-show="item.IsShowContent">
          <div class="content">
            <div v-html="voteInfo.RuleItemList[index].Content"></div>
          </div>
        </div>
        <div class="project_item">
          <div class="score_range">
            打分范围：
            {{ item.ProjectRuleItemMinScore }}
            ~
            {{ item.ProjectRuleItemMaxScore }}
          </div>
        </div>
      </div>
    </div>
    <div class="mobile_vote_operate_box">
      <el-button
        type="primary"
        size="medium"
        class="operate_btn"
        v-if="voteInfo.VoteSubmitConfig.isShow && !voteInfo.IsSubmit"
        :disabled="
          voteInfo.Status !== 1 ||
          voteInfo.IsSubmit !== 0 ||
          !voteInfo.IsVoteAllow
        "
        @click="submitVote()"
      >
        {{ voteInfo.VoteSubmitConfig.textValue }}
      </el-button>
      <el-button
        type="primary"
        size="medium"
        class="operate_btn"
        v-if="voteInfo.VoteResetConfig.isShow && !voteInfo.IsSubmit"
        @click="reset()"
      >
        {{ voteInfo.VoteResetConfig.textValue }}
      </el-button>
      <el-button
        type="primary"
        size="medium"
        class="operate_btn"
        v-if="!voteInfo.IsSubmit"
        @click="openPreview()"
      >
        预览
      </el-button>
      <el-button
        type="primary"
        size="medium"
        class="operate_btn"
        v-if="voteInfo.IsSubmit"
        @click="goBack()"
      >
        返回列表
      </el-button>
      <el-button
        type="primary"
        size="medium"
        class="operate_btn"
        v-if="
          voteInfo.CanSeeResult && voteInfo.IsSubmit && voteInfo.Status === 3
        "
        @click="openResult()"
      >
        查看结果
      </el-button>
    </div>
    <el-drawer
      :visible.sync="showPreview"
      direction="rtl"
      size="100%"
      :show-close="false"
      :withHeader="false"
    >
      <div class="mobile_vote_head">
        <div class="mobile_head_left">
          <a @click="previewGoBack()">
            <i class="el-icon-arrow-left"></i>
          </a>
        </div>
        <span class="mobile_head_desc"> 投票预览 </span>
        <div class="mobile_head_right">
          <a @click="refreshPreview()">
            <i class="el-icon-refresh-right"></i>
          </a>
        </div>
      </div>
      <div class="mobile_vote_bar" ref="mobileVotePreviewBar">
        <div class="mobile_bar_main">
          <div class="mobile_bar_title">
            {{ voteInfoPreview.VoteName }}
          </div>
          <div class="mobile_bar_tips">
            <span> 共：{{ voteInfoPreview.ProjectTotalNum }} </span>
          </div>
        </div>
      </div>
      <div class="mobile_vote_main" :style="votePreviewMainStyle">
        <div
          class="mobile_project_box"
          v-for="(project, index) in voteInfoPreview.VoteProjectList"
          :key="index"
        >
          <div class="project_item">
            <div class="project_title">
              {{ index + 1 }}、{{ project.VoteProjectName }}
            </div>
          </div>
          <div class="project_item">
            <i class="el-icon-s-opportunity icon_left icon_primary"></i>
            <div class="content">
              {{ project.VoteProjectRemark }}
            </div>
            <a
              @click="
                project.IsShowAdditionalRemark = !project.IsShowAdditionalRemark
              "
            >
              <i
                class="el-icon-caret-bottom icon_right icon_primary"
                :style="
                  project.IsShowAdditionalRemark
                    ? 'transform: rotate(-180deg);transition: all .5s'
                    : 'transform: rotate(0deg);transition: all .5s'
                "
              ></i>
            </a>
          </div>
          <div class="project_item" v-show="project.IsShowAdditionalRemark">
            <i
              class="el-icon-s-opportunity icon_left icon_warning"
              v-show="project.VoteProjectAdditionalRemark"
            ></i>
            <div
              class="content"
              v-html="project.VoteProjectAdditionalRemark"
            ></div>
          </div>
          <div class="project_item">
            <div class="font_primary">
              得分：{{ project.AllScore ? project.AllScore : 0 }}
            </div>
            <div class="text_right">原序号：{{ project.Sort }}</div>
          </div>
        </div>
      </div>
      <div class="mobile_vote_operate_box">
        <el-button
          type="primary"
          size="medium"
          class="operate_btn"
          @click="previewGoBack()"
        >
          {{ voteInfo.IsSubmit ? '返回列表' : '返回投票' }}
        </el-button>
        <el-button
          type="primary"
          size="medium"
          class="operate_btn"
          v-if="
            voteInfo.CanSeeResult && voteInfo.IsSubmit && voteInfo.Status === 3
          "
          @click="openResult()"
        >
          查看结果
        </el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import voteApi from '../../api/mobileVote/vote'
export default {
  data () {
    return {
      voteMainStyle: {
        marginTop: '65px'
      },
      voteProjectBoxStyle: {
        top: '65px'
      },
      votePreviewMainStyle: {
        marginTop: '65px'
      },
      voteInfo: {
        VoteProjectList: [],
        VoteSubmitConfig: {},
        VoteResetConfig: {}
      },
      currentProject: {
        ProjectRuleItemList: []
      },
      pageIndex: 1,
      inputPageIndex: 1,
      showPreview: false,
      voteInfoPreview: {
        VoteProjectList: [],
        VoteSubmitConfig: {},
        VoteResetConfig: {}
      }
    }
  },
  methods: {
    goBack: function () {
      if (this.voteInfo.IsSubmit) {
        this.$router.push({ name: 'voteList', params: { mid: this.$route.params.mid } })
      } else {
        this.saveVote('goBack')
      }
    },
    refresh: function () {
      if (this.voteInfo.IsSubmit) {
        this.getShortlistedVoteInfo()
      } else {
        this.saveVote('refresh')
      }
    },
    getScoreVoteInfo: function () {
      const _this = this
      const openLoading = _this.openLoading()
      voteApi.getScoreVoteInfo({
        voteId: _this.$route.params.vid
      }).then(data => {
        _this.voteInfo = data
        _this.currentProject = _this.voteInfo.VoteProjectList[_this.pageIndex - 1]
        _this.$set(_this.currentProject, 'IsShowAdditionalRemark', false)
        _this.currentProject.ProjectRuleItemList.forEach(item => {
          _this.$set(item, 'IsShowContent', false)
          if (item.ProjectRuleItemScore === null) {
            item.ProjectRuleItemScore = undefined
            item.ProjectRuleItemScore_temp = undefined
          }
        })
        if (_this.voteInfo.IsSubmit) {
          _this.openPreview()
        }
        _this.$nextTick(() => {
          _this.voteMainStyle.marginTop = (_this.$refs.mobileVoteBar.offsetHeight + _this.$refs.mobileProjectBox.offsetHeight + 45) + 'px'
          _this.voteProjectBoxStyle.top = (_this.$refs.mobileVoteBar.offsetHeight + 45) + 'px'
        })
        openLoading.close()
      }).catch(err => {
        openLoading.close()
        return err
      })
    },
    changeShowAdditionalRemark: function () {
      const _this = this
      _this.currentProject.IsShowAdditionalRemark = !_this.currentProject.IsShowAdditionalRemark
      _this.$nextTick(() => {
        _this.voteMainStyle.marginTop = (_this.$refs.mobileVoteBar.offsetHeight + _this.$refs.mobileProjectBox.offsetHeight + 45) + 'px'
        _this.voteProjectBoxStyle.top = (_this.$refs.mobileVoteBar.offsetHeight + 45) + 'px'
      })
    },
    prevItem: function () {
      const _this = this
      const openLoading = _this.openLoading()
      if (_this.pageIndex <= 1) {
        _this.$message({
          message: '这已经是第一项了'
        })
      } else {
        _this.voteInfo.VoteProjectList[_this.pageIndex - 1] = _this.currentProject
        _this.pageIndex -= 1
        _this.inputPageIndex = _this.pageIndex
        _this.currentProject = _this.voteInfo.VoteProjectList[_this.pageIndex - 1]
        _this.$set(_this.currentProject, 'IsShowAdditionalRemark', false)
        _this.currentProject.ProjectRuleItemList.forEach(item => {
          _this.$set(item, 'IsShowContent', false)
          if (item.ProjectRuleItemScore === null) {
            item.ProjectRuleItemScore = undefined
            item.ProjectRuleItemScore_temp = undefined
          }
        })
        _this.$nextTick(() => {
          _this.voteMainStyle.marginTop = (_this.$refs.mobileVoteBar.offsetHeight + _this.$refs.mobileProjectBox.offsetHeight + 45) + 'px'
          _this.voteProjectBoxStyle.top = (_this.$refs.mobileVoteBar.offsetHeight + 45) + 'px'
        })
      }
      openLoading.close()
    },
    nextItem: function () {
      const _this = this
      const openLoading = _this.openLoading()
      if (_this.pageIndex >= _this.voteInfo.ProjectTotalNum) {
        _this.$message({
          message: '这已经是最后一项了'
        })
      } else {
        _this.voteInfo.VoteProjectList[_this.pageIndex - 1] = _this.currentProject
        _this.pageIndex += 1
        _this.inputPageIndex = _this.pageIndex
        _this.currentProject = _this.voteInfo.VoteProjectList[_this.pageIndex - 1]
        _this.$set(_this.currentProject, 'IsShowAdditionalRemark', false)
        _this.currentProject.ProjectRuleItemList.forEach(item => {
          _this.$set(item, 'IsShowContent', false)
          if (item.ProjectRuleItemScore === null) {
            item.ProjectRuleItemScore = undefined
            item.ProjectRuleItemScore_temp = undefined
          }
        })
        _this.$nextTick(() => {
          _this.voteMainStyle.marginTop = (_this.$refs.mobileVoteBar.offsetHeight + _this.$refs.mobileProjectBox.offsetHeight + 45) + 'px'
          _this.voteProjectBoxStyle.top = (_this.$refs.mobileVoteBar.offsetHeight + 45) + 'px'
        })
      }
      openLoading.close()
    },
    pageIndexBlur: function () {
      const _this = this
      const openLoading = _this.openLoading()
      if (_this.inputPageIndex < 1 || _this.inputPageIndex > _this.voteInfo.ProjectTotalNum) {
        _this.$message({
          message: '请输入1-' + _this.voteInfo.ProjectTotalNum + '范围内的数值'
        })
      } else {
        _this.voteInfo.VoteProjectList[_this.pageIndex - 1] = _this.currentProject
        _this.pageIndex = _this.inputPageIndex
        _this.currentProject = _this.voteInfo.VoteProjectList[_this.pageIndex - 1]
        _this.$set(_this.currentProject, 'IsShowAdditionalRemark', false)
        _this.currentProject.ProjectRuleItemList.forEach(item => {
          _this.$set(item, 'IsShowContent', false)
          if (item.ProjectRuleItemScore === null) {
            item.ProjectRuleItemScore = undefined
            item.ProjectRuleItemScore_temp = undefined
          }
        })
        _this.$nextTick(() => {
          _this.voteMainStyle.marginTop = (_this.$refs.mobileVoteBar.offsetHeight + _this.$refs.mobileProjectBox.offsetHeight + 45) + 'px'
          _this.voteProjectBoxStyle.top = (_this.$refs.mobileVoteBar.offsetHeight + 45) + 'px'
        })
      }
      openLoading.close()
    },
    projectRuleItemScore_focus: function (item) {
      item.ProjectRuleItemScore_temp = parseFloat(item.ProjectRuleItemScore)
      item.ProjectRuleItemScore = undefined
    },
    projectRuleItemScore_blur: function (currentProject, item) {
      if (!item.ProjectRuleItemScore) {
        item.ProjectRuleItemScore = parseFloat(item.ProjectRuleItemScore_temp)
      }
      currentProject.AllScore = 0
      currentProject.ProjectRuleItemList.forEach(ruleItem => {
        if (ruleItem.ProjectRuleItemScore) {
          currentProject.AllScore += Math.round((ruleItem.ProjectRuleItemScore * ruleItem.ProjectRuleItemScorePercent) * 10000) / 10000
        }
      })
    },
    reset: function () {
      const _this = this
      this.$confirm('确定要将当前项所填写的分数都重置吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'vote_message_box'
      }).then(() => {
        _this.currentProject.AllScore = undefined
        _this.currentProject.ProjectRuleItemList.forEach(item => {
          item.ProjectRuleItemScore = undefined
          item.ProjectRuleItemScore_temp = undefined
        })
        _this.voteInfo.VoteProjectList[_this.pageIndex - 1].AllScore = undefined
        _this.voteInfo.VoteProjectList[_this.pageIndex - 1].ProjectRuleItemList.forEach(item => {
          item.ProjectRuleItemScore = undefined
          item.ProjectRuleItemScore_temp = undefined
        })
      }).catch(() => {

      })
    },
    submitVote: function () {
      const _this = this
      _this.$confirm('确定提交吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'vote_message_box'
      }).then(() => {
        _this.saveVote('submit')
      }).catch(() => {

      })
    },
    saveVote: function (action) {
      const _this = this
      if (action === 'submit') {
        // 检查
        for (let i = 0; i < _this.voteInfo.VoteProjectList.length; i++) {
          for (let j = 0; j < _this.voteInfo.VoteProjectList[i].ProjectRuleItemList.length; j++) {
            if (!_this.voteInfo.VoteProjectList[i].ProjectRuleItemList[j].ProjectRuleItemScore) {
              _this.$message({
                type: 'error',
                message: '存在未打分的项'
              })
              _this.inputPageIndex = i + 1
              _this.pageIndexBlur()
              return
            }
          }
        }
      }

      // 提交参数
      const voteProjectList = []
      _this.voteInfo.VoteProjectList.forEach(projectItem => {
        const voteProject = {}
        voteProject.VoteProjectId = projectItem.VoteProjectID
        voteProject.AllScore = projectItem.AllScore
        voteProject.ProjectRuleItemList = []
        projectItem.ProjectRuleItemList.forEach(item => {
          const voteProjectRuleItem = {}
          voteProjectRuleItem.ProjectRuleItemID = item.ProjectRuleItemID
          voteProjectRuleItem.ProjectRuleItemScore = item.ProjectRuleItemScore
          voteProject.ProjectRuleItemList.push(voteProjectRuleItem)
        })
        voteProjectList.push(voteProject)
      })
      const param = {
        VoteId: _this.voteInfo.VoteID,
        Action: 'all_save',
        VoteProjectList: voteProjectList
      }
      if (action === 'submit') {
        param.Action = 'submit'
      }
      // 提交
      const openLoading = _this.openLoading()
      voteApi.scoreVote(param).then(data => {
        if (action === 'save') {
          _this.getScoreVoteInfo()
          _this.$message({
            type: 'success',
            message: '已保存'
          })
        }
        if (action === 'submit') {
          _this.getScoreVoteInfo()
          _this.$message({
            type: 'success',
            message: '投票已提交'
          })
          _this.openPreview()
        }
        if (action === 'goBack') {
          this.$router.push({ name: 'voteList', params: { mid: this.$route.params.mid } })
        }
        if (action === 'refresh') {
          _this.getScoreVoteInfo()
        }
        openLoading.close()
      }).catch(err => {
        openLoading.close()
        return err
      })
    },
    openPreview: function () {
      const _this = this
      const openLoading = _this.openLoading()
      _this.voteInfoPreview = JSON.parse(JSON.stringify(_this.voteInfo))
      _this.$nextTick(() => {
        _this.votePreviewMainStyle.marginTop = (_this.$refs.mobileVotePreviewBar.offsetHeight + 45) + 'px'
      })
      _this.showPreview = true
      openLoading.close()
    },
    refreshPreview: function () {
      const _this = this
      const openLoading = _this.openLoading()
      _this.voteInfoPreview = JSON.parse(JSON.stringify(_this.voteInfo))
      openLoading.close()
    },
    previewGoBack: function () {
      const _this = this
      if (_this.voteInfo.IsSubmit) {
        this.$router.push({ name: 'voteList', params: { mid: this.$route.params.mid } })
      } else {
        _this.showPreview = false
      }
    },
    openResult: function () {
      this.$router.push({ name: 'result', params: { mid: this.$route.params.mid, vid: this.$route.params.vid, voteType: 0 } })
    }
  },
  mounted () {
    this.getScoreVoteInfo()
  }
}
</script>

<style lang="less">
@import '../../assets/css/mobileVote/vote.css';
.el-drawer__body {
  overflow: auto;
}
</style>
